<template>
  <el-menu class="navbar" mode="horizontal">
    <hamburger v-if="!suspension" style="margin-left: 14px;" class="hamburger-container" :toggleClick="toggleSideBar"
      :isActive="sidebar.opened"></hamburger>
    <div class="logo" style="display: flex;align-items: center;justify-content: center; width:200px !important;">
      <el-input class="ipoo" v-model="selectinput" clearable @clear="selectCg" @keyup.enter.native="selectCg"
        style="width: 150px !important; color: #fff;margin-left: -40px;" size="small" placeholder="回车搜索">
        <!-- <template slot="prepend" style="border: none;">
          <i class="el-icon-search"></i>
        </template> -->
      </el-input>
    </div>
    <div class="logo" style="display: flex;align-items: center; margin-left: -30px;">
      <img class="user-avatar" :src="logo">
      <div v-if="suspension">
        <i class="el-icon-arrow-down inooo" @click="scrollbar" v-if="scrollbarvalue"></i>
        <i class="el-icon-arrow-up inooo" @click="scrollbar" v-else></i>
      </div>
    </div>


    <div class="conetnt-right">
      <div class="df-left">
        <!-- 所在部门 :  -->
      </div>
      <div class="df-right">
        <div class="medio">

          <div style="display: flex;align-items: center;" v-if="departmentoptions.children">
            <i class="el-icon-s-shop" style="font-size: 20px; margin-right: 0px;"></i>
            <el-select size="mini" v-model="department" placeholder="请选择" @change="changedepartment">
              <el-option v-for="item in this.departmentoptions.children" :key="item.deptCode" :label="item.name"
                :value="item.deptCode">
              </el-option>
            </el-select>
          </div>
          <div v-if="departmentoptions" class="xiaGk"></div>
        </div>

        <div class="iconclass" style="cursor: pointer;">
          <el-dropdown trigger="click" @command="handleCommand">
            <i class="el-icon-s-tools" style="font-size: 20px;color: #fff;"></i>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="Zti">切换圆形主题
                <el-switch v-model="switchVal" active-color="#66B1FF" inactive-color="#e8e4e4" @change="switchChange">
                </el-switch>
              </el-dropdown-item>
              <el-dropdown-item command="Zti">悬浮菜单栏
                <el-switch v-model="suspension" active-color="#66B1FF" inactive-color="#e8e4e4"
                  @change="suspensionChange">
                </el-switch>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div class="iconclass" style="cursor: pointer;" @click.stop="gomessage()"
          @contextmenu.prevent.stop="openMenu($event)">
          <el-badge :value="totalMsg" class="reditem">
            <i class="el-icon-bell" style="font-size: 20px;color: #fff;"></i>
          </el-badge>
        </div>
        <div class="iconclass" style="cursor: pointer;">
          <i class="el-icon-refresh" @click="refresh" style="font-size: 20px;color: #fff;"></i>
        </div>
        <div class="iconclass" style="cursor: pointer;">
          <i class="el-icon-switch-button" @click="logout" style="font-size: 20px;color: #fff;"></i>
        </div>
        <div class="xiaGk"></div>
        <el-dropdown @command="handleCommand" trigger="click" :hide-on-click="false">
          <div class="avatar-wrapper" style="color: #fff;">
            {{ username }}
            <i class="el-icon-caret-bottom"></i>
          </div>
          <el-dropdown-menu class="user-dropdown" slot="dropdown">
            <el-dropdown-item command="handleGoProfile">
              <span>个人中心</span>
            </el-dropdown-item>
            <el-dropdown-item divided>

              <div style="display: flex; align-items: center;">
                切换主题颜色
                <el-color-picker @change="mainbgchg('mainbg', currentTheme)" style="margin-left: 10px;" size="mini"
                  v-model="currentTheme"></el-color-picker>
              </div>
            </el-dropdown-item>
            <el-dropdown-item divided>
              <div style="display: flex; align-items: center;">
                切换背景颜色
                <el-color-picker @change="mainbgchg('frigthbg', mbgcurrentTheme)" style="margin-left: 10px;" size="mini"
                  v-model="mbgcurrentTheme"></el-color-picker>
              </div>
            </el-dropdown-item>
            <el-dropdown-item divided>
              <div style="display: flex; align-items: center;">
                切换二级背景颜色
                <el-color-picker @change="mainbgchg('torbg', rowmbgcurrentTheme)" style="margin-left: 10px;" size="mini"
                  v-model="rowmbgcurrentTheme"></el-color-picker>
              </div>
            </el-dropdown-item>
            <el-dropdown-item divided>
              <div style="display: flex; align-items: center;">
                切换字体颜色
                <el-color-picker @change="mainbgchg('textcolor', textcurrentTheme)" style="margin-left: 10px;" size="mini"
                  v-model="textcurrentTheme"></el-color-picker>
              </div>
            </el-dropdown-item>
            <el-dropdown-item command="chagendefilter" divided>
              <span>切换主题</span>
            </el-dropdown-item>
            <el-dropdown-item command="FollowWeChat" divided>
              <el-popover v-model="visible" placement="left-start" title="微信二维码" trigger="click" content="centent">
                <viewer :images="anliList">
                  <img @click="FollowWeChatcolse" :src="WcImgValue" class="slimg"
                    style="width: 160px; height: 160px; cursor: pointer;">
                </viewer>
                <span slot="reference">关注微信</span>
              </el-popover>
            </el-dropdown-item>
            <el-dropdown-item command="logout" divided>
              <span>退出</span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <el-dialog title="主题颜色选择" :visible.sync="dialogVisible" :modal="false" width="70%" :before-close="handleClose">
      <div class="XZ">
        <div class="BD" v-for="(i, index) in colorTermList" :key="index" @click="QH(i)">
          <div class="BD-left" :style="`background-color:${i.color}`">
          </div>
          <div class="BD-tight">
            <div class="BD-tight-hd">
              <span :style="`color:${i.color}`">{{ i.title }} </span><span style="font-size: 10px;">{{ i.Py }}</span>
            </div>
            <div class="BD-tight-bd">
              {{ i.color }} rgb{{ i.rgb }}
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>

      </span>
    </el-dialog>
    <ul class='contextmenu' v-show="visibleMx" :style="{ left: left + 'px', top: top + 'px' }">
      <li @click="cleatMsg">清除消息</li>
    </ul>
  </el-menu>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Hamburger from '@/components/Hamburger'
import logo from '@/assets/dllogo2.png'
import * as login from '@/api/login'
import Bus from "@/utils/EventBus";

import colorTermList from "./tremBc.js";
export default {
  inject: ['reload'],
  data: function () {
    return {
      logo: logo,
      theme: 0,
      department: '',
      username: '',
      currentTheme: "#0f74ff", // 默认主题
      textcurrentTheme: '#1273e6',//选中字体颜色
      mbgcurrentTheme: '#ffffffff',//背景颜色
      rowmbgcurrentTheme: "#ffffffff", // 二级背景颜色
      defTheme: '0px',
      WcImgValue: require('../../../assets/404_images/404.png'),
      anliList: [],
      departmentoptions: {},
      switchVal: false,
      suspension: false,
      left: '',
      top: '',
      selectinput:'',
      visibleMx: false,
      scrollbarvalue: true,
      totalMsg: '',
      visible: false,
      Bgobj: {},
      dialogVisible: false,
      colorTermList: []
    }
  },
  components: {
    Hamburger
  },
  computed: {
    ...mapGetters(['sidebar', 'isIdentityAuth', 'name', 'themeStatus']),
    primaryColor() {
      return this.currentTheme
    },
    textprimaryColor() {
      return this.textcurrentTheme
    },
    mbcprimaryColor() {
      return this.mbgcurrentTheme
    },
    rowmbcprimaryColor() {
      return this.rowmbgcurrentTheme
    },
    MXdefTheme() {
      return this.defTheme
    }

  },
  created() {
    this.colorTermList = colorTermList


    let bg = JSON.parse(window.localStorage.getItem('background'))
    if (bg) {
      this.currentTheme = bg.mainbg || '#0f74ff'
      this.textcurrentTheme = bg.textcolor || '#1273e6'
      this.mbgcurrentTheme = bg.frigthbg || '#ffffffff'
      this.rowmbgcurrentTheme = bg.torbg || '#ffffffff'
      this.defTheme = bg.DefRowshape
      this.switchVal = bg.switchVal
      this.suspension = bg.suspension

    }

    this.username = window.localStorage.getItem('username') || ''

    const departmentRaw = JSON.parse(window.localStorage.getItem('department'))
    const currentDept = JSON.parse(window.localStorage.getItem('Currentdepartment'))

    if (departmentRaw && Array.isArray(departmentRaw) && departmentRaw.length > 0) {
      this.departmentoptions = departmentRaw[0]
      this.department = currentDept

      if (this.departmentoptions.length > 0 && this.department) {
        this.departmentoptions.forEach(x => {
          if (x.children) {
            x.children.forEach(y => {
              if (y.orgName == this.department.parentName) {
                this.departmentoptions = y
              }
            })
          }
        })
      }

      this.department = currentDept ? currentDept.deptCode : ''
    } else {
      this.departmentoptions = {}
      this.department = ''
    }


  },
  watch: {
    totalMsg(newValue, oldValue) {
      console.log('newValue', newValue);
      if (newValue) {
        this.totalMsg = newValue
      }
    },
    deep: true,
    theme() {
      this.toggleClass(document.body, 'custom-theme')
    },
    currentTheme() {
      document.documentElement.style.setProperty(
        "--primary-color",
        this.primaryColor
      );
    },
    textcurrentTheme() {
      document.documentElement.style.setProperty(
        "--text-color",
        this.textprimaryColor
      );
    },
    mbgcurrentTheme() {
      document.documentElement.style.setProperty(
        "--background-color",
        this.mbcprimaryColor
      );
    },
    rowmbgcurrentTheme() {
      document.documentElement.style.setProperty(
        "--twobackground-color",
        this.rowmbcprimaryColor
      );
    },
    defTheme() {
      document.documentElement.style.setProperty(
        "--defTheme-radius",
        this.MXdefTheme
      );
    }





  },
  mounted() {
    this.theme = Number(this.themeStatus)
    this.toggleClass(document.body, 'custom-theme')
  },

  methods: {
    ...mapActions([
      'signOutOidc',
      'saveTheme'
    ]),
    openMenu(e) {
      this.visibleMx = true
      const offsetLeft = this.$el.getBoundingClientRect().left // container margin left
      if (e.clientX - offsetLeft < 50) {
        this.left = e.clientX - offsetLeft + 80
      } else {
        this.left = e.clientX - offsetLeft - 100  // 15: margin right
      }
      this.top = e.clientY
    },
    scrollbar() {
      this.scrollbarvalue = !this.scrollbarvalue
      this.$emit('child-click'); // 触发一个名为child-click的事件，将方法作为参数传递给父组件
    },
    loader() {
      if (JSON.parse(window.localStorage.getItem('MsgArrayTotal'))) {
        this.totalMsg = JSON.parse(window.localStorage.getItem('MsgArrayTotal')).totalMsg
      }
    },
    switchChange(val) {
      if (val) {
        this.defTheme = '20px'
      } else {
        this.defTheme = '0px'
      }
      this.mainbgchg('switchVal', val)
      this.mainbgchg('DefRowshape', this.defTheme)
    },
    suspensionChange(val) {
      this.mainbgchg('suspension', this.suspension)
      location.reload();
    },
    selectCg() {
      Bus.$emit("Cdchage", this.selectinput);
    },
    tools() {
    },
    getWcim() {

      login.getWcimg().then(res => {
        this.WcImgValue = res.result.qrCodeUrl
      }).catch(err => {
        this.WcImgValue = require('../../../assets/404_images/404.png')
      })
    },
    gomessage() {
      Bus.$emit("MsgshowD");
    },
    refresh() {
      // this.reload()
      this.$emit('refresh')
    },
    switchTheme(theme) {
      this.currentTheme = theme;
    },
    mainbgchg(stringd, Bhmg) {

      this.Bgobj = JSON.parse(window.localStorage.getItem('background')) || {};
      this.Bgobj[stringd] = Bhmg;
      window.localStorage.setItem('background', JSON.stringify(this.Bgobj));
    },


    toggleClass(element, className) {

      if (!element || !className) {
        return
      }
      let classString = element.className
      const nameIndex = classString.indexOf(className)
      if (nameIndex === -1) {
        classString += '' + className
      } else if (this.theme !== 1) {
        classString =
          classString.substr(0, nameIndex) +
          classString.substr(nameIndex + className.length)
      }
      element.className = this.theme === 1 ? classString : ''
      this.saveTheme(this.theme)
    },
    toggleSideBar() {
      this.$store.dispatch('ToggleSideBar')
    },
    logout() {
      if (this.isIdentityAuth) {
        this.signOutOidc()
      } else {
        this.$store.dispatch('LogOut').then(() => {
          location.reload() // 为了重新实例化vue-router对象 避免bug
        })
        window.localStorage.removeItem('Currentdepartment');
        window.localStorage.removeItem('department');
        window.localStorage.removeItem('username');
        window.localStorage.removeItem('modules');
        window.localStorage.removeItem('routers');

      }
    },
    handleClose() {
      this.dialogVisible = false
    },
    chagendefilter() {
      this.dialogVisible = true
    },
    FollowWeChat() {
      this.getWcim()

    },
    FollowWeChatcolse() {
      this.visible = false
    },
    QH(row) {
      this.Bgobj.mainbg = row.color
      this.Bgobj.frigthbg = '#ffffffff'
      this.Bgobj.torbg = '#ffffffff'
      this.Bgobj.textcolor = row.color
      this.currentTheme = this.Bgobj.mainbg
      this.textcurrentTheme = this.Bgobj.textcolor
      this.mbgcurrentTheme = this.Bgobj.frigthbg
      this.rowmbgcurrentTheme = this.Bgobj.torbg
      window.localStorage.setItem('background', JSON.stringify(this.Bgobj))
    },
    changedepartment(e) {
      let selectBm = []
      this.departmentoptions.children.forEach(x => {
        if (x.deptCode == e) {
          window.localStorage.setItem('Currentdepartment', JSON.stringify(x))
          selectBm.push(x)
        }
      })
      login.getDept({
        code: e
      }).then(res => {
        let orginfo = []
        orginfo.push(this.departmentoptions)
        this.$store.dispatch('SET_DEFAULTORG', orginfo)
        this.$store.dispatch('SetDetpInfo', selectBm)
        this.reload()
      })



    },
    handleGoProfile() {
      this.$router.push('/profile')
    },
    handleCommand(name) {
      if (!name) return
      this[name]()
    },
    Zti() {
      // console.log(798);
      // window.localStorage.setItem('border-radius','20px')
    },
    cleatMsg() {
      window.localStorage.removeItem('MsgArrayTotal')
      window.localStorage.removeItem('MsgArray')
      this.visibleMx = false
      this.totalMsg = ''
    },
  }
}
</script>

<style rel="stylesheet/scss" lang="less" scoped>
.navbar {
  background-color: #0f74ff;
  background-image: linear-gradient(90deg, var(--primary-color) 0%, #2cdad4 100%);
  height: 30px !important;
  /* // background-color: var(--primary-color); */
}

.conetnt-right {
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: red;

  .df-left {
    // background-color:#304156;
    border-radius: 10px;
    margin-left: 20px;
  }

  .df-right {
    display: flex;
    align-items: center;

    color: #fff;
    margin-right: 20px;
  }

}

/deep/.el-input__inner {
  background-color: transparent;
  color: #fff;
  // border: 1px solid #e43179;
  border: none;
  max-width: 130px;
}

/deep/ .el-select .el-input .el-select__caret {
  color: #fff !important;
}


.medio {
  display: flex;
  align-items: center;
}

@media (max-width: 628px) {
  .medio {
    display: none;
  }
}

/* // @media (max-width: 480px) {
  //   .container {
  //     padding: 5px;
  //   }
  // } */

.XZ {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  max-height: 50vh;
  overflow: auto;

  .BD {
    flex: 20%;
    background-color: #fff;
    box-shadow: 1px 1px 8px 1px #ccc;
    margin: 10px 20px;
    padding: 20px;
    cursor: pointer;

    .BD-left {
      height: 10px;
    }

    .BD-tight {}
  }
}

.iconclass {
  position: relative;
  margin-right: 16px;
}

/deep/ .el-badge__content.is-fixed {
  position: absolute;
  top: 10px;
  right: 10px;
  /* transform: translateY(-50%) translateX(100%); */
}

.xiaGk {
  // background-color: #cfcfcf;
  height: 14px;
  // width: 1px;
  border-right: 2px solid #cfcfcf;
  margin-right: 10px;
}

.contextmenu {
  margin: 0;
  background: #fff;
  z-index: 10000;
  position: absolute;
  list-style-type: none;
  padding: 5px 0;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 400;
  color: #333;
  box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, 0.3);

  li {
    margin: 0;
    padding: 7px 16px;
    cursor: pointer;

    &:hover {
      background: #eee;
    }
  }
}

.inooo {
  margin-left: 20px;
  font-size: 20px;
  color: #fff;
  cursor: pointer;
}
/deep/ .ipoo .el-input__inner {
  background-color: #fff !important;
  color: #000 !important;
  border-radius: 4px !important;
  width: 200px !important;
}
</style>